import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import css from './popup-menu.scss';

const PopUpMenu = ({ downloadDisabled, isClassLevel, options, downloadCertificateOrReports }) => {
    const menu = options.map((item, index) => (
        <button
            key={item.label}
            id={index}
            aria-hidden={'true'}
            className={
                `${css['popup-menu-item']}
                ${downloadDisabled && index === 0 ? css.popupDisabled : ''}`
            }
            /* TODO uncomment when participation option is needed
                 ${isClassLevel ? '' : css.popupMenuItemSingleItem} */
            disabled={downloadDisabled && index === 0}
            onClick={downloadCertificateOrReports}
        >
            {item.value}
        </button>
    )
    );

    return (
        <div className={
            `${css['popup-menu']}
            ${isClassLevel ? css.moveLeft : ''}`}>
            {/* TODO uncomment when participation option is needed */}
            {/* ${isClassLevel ? '' : css.popupMenuSingleItem} */}
            { menu }
        </div>
    );
};

PopUpMenu.propTypes = {
    downloadDisabled: PropTypes.bool,
    isClassLevel: PropTypes.bool,
    options: PropTypes.array,
    downloadCertificateOrReports: PropTypes.func
};

export default styleable(css)(PopUpMenu);




// WEBPACK FOOTER //
// ./containers/overview/sub-components/popup-menu.js